import { render, staticRenderFns } from "./MixItemFeedGoods.vue?vue&type=template&id=29d248cc&scoped=true&"
import script from "./MixItemFeedGoods.vue?vue&type=script&lang=js&"
export * from "./MixItemFeedGoods.vue?vue&type=script&lang=js&"
import style0 from "./MixItemFeedGoods.vue?vue&type=style&index=0&id=29d248cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d248cc",
  null
  
)

export default component.exports